module.exports = __webpack_public_path__ + "img/source03_b6.68884959.png";